import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import { Link } from "react-router-dom"

class MenuItem extends React.Component {
  render() {
    const { path, isActive, children } = this.props
    return (
      <Link to={path}> 
      <div className={cx(styles.menuItemBox, {[styles.menuItemBoxActive]: isActive})}>
        <div className={cx(styles.menuItem, {[styles.menuItemActive]: isActive})}/>
        <div className={styles.content}>
        {children}    
        </div>
      </div>
      </Link>
    )
  }
}

export default MenuItem


// WEBPACK FOOTER //
// src/components/SideNav/MenuItem/index.jsx